import ash from '../images/gameStudios/ash.svg';
import eyecon from '../images/gameStudios/eyecon.svg';
import geco from '../images/gameStudios/geco.svg';
import origins from '../images/gameStudios/origins.svg';
import psiclone from '../images/gameStudios/psiclone.svg';
import rarestone from '../images/gameStudios/rarestone.svg';
import skywind from '../images/gameStudios/skywind.svg';
import sunfox from '../images/gameStudios/sunfox.svg';
import vikings from '../images/gameStudios/vikings.svg';
import quickspin from '../images/gameStudios/quickspin.svg';

export default {
    ash,
    eyecon,
    geco,
    origins,
    psiclone,
    rarestone,
    skywind,
    sunfox,
    vikings,
    quickspin
};
